<template>
  <!--    园区活动列表-->
  <div class="garden_activity">
    <div class="m">
      <div class="classify_box">
        <!-- 区域 -->
        <type_filter :filterObj="filterObj" filedType="code" @selctedType="selctedType"></type_filter>
        <!-- 活动类型 -->
        <type_filter :filterObj="filterObj2" @selctedType="selctedType"></type_filter>
        <!-- 状态 -->
        <!-- <type_filter :filterObj="filterObj3" @selctedType="selctedType"></type_filter> -->
      </div>
      <div class="normal_box">
        <!--常规筛选-->
        <type_filter :filterObj="filterObj4" @selctedType="selctedType"></type_filter>
      </div>

      <div class="gardenList_box">
        <ul v-if="list.length">
          <park-activities :list="list" />
        </ul>
        <div class="no_data" v-else>
          <img src="@/assets/img/common/no_data.png" alt />
          <p>没有相关的信息哦</p>
        </div>
      </div>

      <div class="page_box">
        <myPage :layerpageinfo="layerpageinfo" @pageChange="changePage"></myPage>
      </div>
    </div>
  </div>
</template>

<script>
import parkActivities from "@/components/list/park_activities/list.vue";
import type_filter from "@/components/type_filter/type_filter.vue";
import myPage from "@/components/myPage/myPage";
export default {
  components: {
    type_filter,
    myPage,
    parkActivities
  },
  data() {
    return {
      searchObj: {
        province: "GuangdongCity",
        city: "", //地区
        activitytype: "", //活动类型
        status: "", // 状态
        sort: "" //排序
      },
      layerpageinfo: {
        pageSize: 10,
        pageNo: 0,
        total: 0
      },
      list: [], //园区列表
      filterObj: {
        //地区筛选对象
        name: "地区",
        code: "city",
        list: []
      },
      filterObj2: {
        //活动类型筛选对象
        name: "活动类型",
        code: "type",
        list: []
      },
      filterObj3: {
        //状态筛选对象
        name: "状态",
        code: "status",
        list: []
      },
      filterObj4: {
        //排序筛选对象
        name: "",
        code: "sort",
         list:  [
          {
            code: "SortDefault",
            name: "默认",
          },
          {
            code: "SortPriceASC",
            name: "价格升序",
          },
          {
            code: "SortPriceDESC",
            name: "价格降序",
          },
          {
            code: "SortTimeASC",
            name: "时间升序",
          },
          {
            code: "SortTimeDESC",
            name: "时间降序",
          },
          {
            code: "SortPopularity",
            name: "人气升序",
          },
          {
            code: "SortPopularityDESC",
            name: "人气降序",
          },
        ]
      }
    };
  },
  mounted() {
    // 条件查询活动列表
    this.getActives();
    // 获取所有类型的字典
    this.initParams();
  },
  methods: {
    // 条件查询活动列表
    getActives() {
      let obj = Object.assign({}, this.searchObj, this.layerpageinfo);
      this.api.getActives(obj).then(res => {
        console.log(res);
        if (res.error.err_code != 0) return;
        let list = res.obj.list || [];
        this.list = list;
        this.layerpageinfo.total = res.obj.totalSize;
      });
    },
    //获取所有类型的字典
    initParams() {
      // 地区
      this.getDictionaries("GuangdongCity").then(res => {
        this.filterObj.list = res;
      });
      // 活动类型
      this.getDictionaries("ActiveType").then(res => {
        this.filterObj2.list = res;
      });
      // 状态
      // this.getDictionaries("ActiveStatus").then(res => {
      //   this.filterObj3.list = res;
      // });
      // // 排序
      // this.getDictionaries("Sort").then(res => {
      //   this.filterObj4.list = res;
      // });
    },
    /**获取对应类型字典
     * @params type 字典类型
     * */
    getDictionaries(type) {
      let obj = {
        typeCode: type,
        pageNo: 0,
        pageSize: 999
      };
      return new Promise(resolve => {
        this.api.getDictionaries(obj).then(res => {
          if (res.error.err_code !== 0) return;
          let list = res.obj.list;
          list = list.length ? list : null;
          resolve(list);
        });
      });
    },
    // 选择筛选条件
    selctedType(obj) {
      console.log(obj);
      if (obj.filedType === "code") {
        this.searchObj[obj.code] = obj.list.code;
      } else {
        this.searchObj[obj.code] = obj.list.id;
      }
      if(obj.code === 'city'){
        if(!obj.list.code){
          this.searchObj.province = '';
        }
        else{
          this.searchObj.province = 'GuangdongCity'
        }
      }
      if(obj.code === 'sort'){
        if(!obj.list.code){
          this.searchObj.sort = '';
        }
        else{
          this.searchObj.sort = obj.list.code;
        }
      }
      this.layerpageinfo.pageNo = 0;
      this.getActives();
    },
    // 页数切换
    changePage(pageNo) {
      this.layerpageinfo.pageNo = pageNo;
      this.getActives();
    }
  }
};
</script>

<style lang="scss">
.garden_activity {
  padding-top: 18px;
  .m {
    height: 100%;
    .classify_box {
      background: #ffffff;
      padding: 15px;
      margin-bottom: 15px;
    }
    .normal_box {
      background: #fff;
      padding: 0 20px;
      margin-bottom: 20px;
    }
  
    .page_box {
      text-align: center;
      padding: 24px 0px 40px;
    }
    .gardenList_box{
      .no_data{
        text-align: center;
      }
    }
  }
}
</style>